export const isEnabled = (value: unknown): boolean =>
  value === true || value === 1 || value === '1';
